import getApi from '../../../api'

export const lockUser = (userId: string) => getApi().put<null>(`/admin/users/${userId}/lock`)

export const unlockUser = (userId: string) => getApi().put<null>(`/admin/users/${userId}/unlock`)
